import {
  Dimensions,
  StyleSheet,
  View,
  TouchableOpacity,
  Text,
} from "react-native";
import React from "react";
import InputText from "../../../components/InputText";
import { useForm } from "react-hook-form";
import Colors from "../../../constants/Colors";
import Animated, {
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withTiming,
} from "react-native-reanimated";
import OptionSelect from "./OptionSelect";
import GlobalContext from "../../../context/Global";
import { useGetQuestionAnswers } from "../../../hooks/useGetQuestionAnswers";

const { width } = Dimensions.get("window");

interface QuestionSelectProps {
  question: string;
  details: string;
  options: string[];
  onPress: (value: any) => void;
  uuid: string;
  prefetchedAnswers?: any;
}

const QuestionSelect: React.FC<QuestionSelectProps> = ({
  question,
  details,
  options,
  onPress,
  uuid,
  prefetchedAnswers,
}) => {
  const { isTablet } = React.useContext(GlobalContext);
  const {
    control,
    formState: { errors },
  } = useForm();
  const { data: fetchedAnswers } = useGetQuestionAnswers(uuid);

  const answers = prefetchedAnswers || fetchedAnswers;

  const resolvedAnswers =
    answers && Array.isArray(answers) && answers.length > 0
      ? answers
      : options.map((option) => ({
          uuid: option,
          label: option,
          question_uuid: uuid,
        }));

  const [selected, setSelected] = React.useState<number | null>(null);
  return (
    <View style={styles.page}>
      <View style={styles.container}>
        <Text style={isTablet ? styles.questionText : styles.phoneQuestionText}>
          {question}
        </Text>
        {details ? (
          <Text style={isTablet ? styles.detailsText : styles.phoneDetailsText}>
            {details}
          </Text>
        ) : null}
        <View style={isTablet ? styles.optionRow : styles.phoneRow}>
          {resolvedAnswers.map((answer: any, index: number) => (
            <OptionSelect
              key={answer.uuid || index}
              index={index}
              option={answer.label}
              selected={selected}
              setSelected={() => {
                setSelected(index);
                onPress(answer);
              }}
            />
          ))}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  page: {
    width: "100%",
    alignItems: "center",
    paddingHorizontal: 20,
    paddingTop: 20,
  },
  container: {
    alignItems: "center",
    width: "100%",
    maxWidth: 500,
  },

  questionText: {
    marginBottom: 20,
    textAlign: "center",
    fontSize: 26,
    fontFamily: "NunitoRegular",
    color: Colors.nuetral_grey_700,
  },
  phoneQuestionText: {
    marginBottom: 10,
    textAlign: "center",
    fontSize: 26,
    fontFamily: "NunitoRegular",
    color: Colors.nuetral_grey_700,
  },
  detailsText: {
    textAlign: "center",
    color: Colors.nuetral_grey_700,
    marginBottom: 80,
    fontSize: 20,
    fontFamily: "NunitoRegular",
  },
  phoneDetailsText: {
    textAlign: "center",
    color: Colors.nuetral_grey_700,
    marginBottom: 20,
    fontSize: 20,
    fontFamily: "NunitoRegular",
  },
  optionRow: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginTop: 20,
    flexWrap: "wrap",
    width: width,
  },
  phoneRow: {
    justifyContent: "center",
    alignItems: "center",
    width: width,
    maxWidth: 500,
  },
});

export default QuestionSelect;
